import styled from 'styled-components'

interface toastProps {
  isShow: boolean
}

const ToastWrap = styled.div<toastProps>`

  @media (max-width: 320px) {
    width: 300px;
  }
  @media (min-width: 321px) {
    width: 320px;
  }
  margin: 0 auto 16px auto;

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  padding: 15px 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 4px;
  background: #2d2e30;
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.1);

  transition: all 0.5s;

  visibility: ${(props) => (props.isShow ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.isShow ? '1' : '0')};
`
const ToastText = styled.div`
  color: #fff;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export { ToastWrap, ToastText }
